import { checkInternet, checkServer, fetchWithTimeout } from "../utils/errors";
import { sessionStorageUtil } from "../utils/storage";

export const loginUserWithEmailAndPassword = async (data) => {
  const token = process.env.REACT_APP_API_GUEST_TOKEN;

  const { email, password } = data;

    // 1) “Am I online at all?”
  // try {
  //   await checkInternet();
  // } catch (e) {
  //   // if (showError) toast.error("Please check your Internet connection.");
  //   // console.log(e);
  //   return {
  //     error: true,
  //     message: e.message
  //   }
  // }

  // 2) “Is the server up?”
  try {
    await checkServer(process.env.REACT_APP_API_BASE_URL);
  } catch (e) {
    // if (showError) toast.error("Server is not responding. Please try again later.");
    // console.log(e);
    return {
      error: true,
      message: e.message
    }
    // throw e;
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user/app-login`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
        user_type: "UNITHOLDER",
      }),
    });
    // const opts = {
    //   method: "POST",
    //   headers: {
    //     Authorization: token,
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({
    //     email,
    //     password,
    //     user_type: "UNITHOLDER",
    //   }),
    // }
    // const response = await fetchWithTimeout(`${process.env.REACT_APP_API_BASE_URL}/user/app-login`, opts, 5000);

    const data = await response.json();

    if (response.ok && data.status === 300) {
      return {
        message: data.message,
        error: false,
        type: "bypass",
      };
    }

    if (!response.ok || data?.status !== 200) {
      throw new Error(data.message || "Failed to Login");
    }

    return {
      data,
      message: "Login Successful",
      error: false,
    };
  } catch (error) {
    // console.log(error);

    // if (error.name === 'AbortError') {
    //   return {
    //     data: null,
    //     message: 'Request timed out',
    //     error: true,
    //   };
    // }

    // if (error instanceof TypeError) {
    //   return {
    //     data: null,
    //     message: 'Server is not responding. Try again later.',
    //     error: true,
    //   };
    // }

    return {
      data: null,
      message: error.message || "Failed to Login",
      error: true,
    };
  }
};

export const signupUser = async (data) => {
  const token = process.env.REACT_APP_API_GUEST_TOKEN;
  const email = process.env.REACT_APP_API_GUEST_EMAIL;

  const amcCode = sessionStorageUtil.getAmcCode();

  // console.log(data);

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user/register-app-user`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...data,
        name: data.name,
        email,
        amc_code: amcCode,
        salutations: data.salutations,
        // occupation: data.occupation.value,
        // city: data.city.value?.name,
        // province: data.province.value,
        // country: data.country.value,
      }),
    });

    const result = await response.json();

    // console.log(result);

    if (!response.ok || result?.status !== 200 || Object.keys(result).length === 0) {
      throw new Error(result.message || "User Already Exists.");
    }

    return {
      data,
      message: result.message || "User Registered Successfully",
      error: false,
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      message: error.message,
      error: true,
    };
  }
};

export const loginUserWithOtp = async (email) => {
  // console.log(email);

  const token = process.env.REACT_APP_API_GUEST_TOKEN;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user/generate-otp`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
      }),
    });

    const data = await response.json();

    // console.log(data);

    if (!response.ok || data?.status !== 200) {
      if (data.status == 404) {
        throw new Error("User does not exist");
      } else {
        throw new Error(data.message || "Failed to Login");
      }
    }

    return {
      data,
      message: "Login Successfull",
      error: false,
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      message: error.message,
      error: true,
    };
  }
};

export const verifyUserWithOtp = async (email, otp) => {
  const token = process.env.REACT_APP_API_GUEST_TOKEN;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user/verify-otp-app`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        otp,
      }),
    });

    const data = await response.json();

    // console.log(data);

    if (!response.ok || data?.status !== 200) {
      throw new Error(data.message || "Invalid Otp");
    }

    return {
      data,
      message: "Otp Verification Successfull",
      error: false,
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      message: error.message || "Invalid Otp",
      error: false,
    };
  }
};

export const getUnitholderDetails = async (email, folioNo = '') => {
  const token = sessionStorageUtil.getAccessToken();
  const amcCode = sessionStorageUtil.getAmcCode();

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/unit-holder/by-amc-code-and-folio-no?email=${encodeURIComponent(email)}&folio_no=${encodeURIComponent(folioNo)}&amc_code=${encodeURIComponent(amcCode)}`,
      {
        method: "GET",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      },
    );

    const results = await response.json();

    if (!response.ok || results?.status !== 200) {
      throw new Error(results.message || "Get Unitholder Details - Failed");
    }

    return {
      data: results.data,
      message: "Get Unitholder Details - Success",
      error: false,
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      message: error.message || "Get Unitholder Details - Failed",
      error: true,
    };
  }
};

/**
 * Convert JS object -> FormData with options.
 *
 * Options:
 *  - useJsonForNestedObjects: boolean (default true)
 *      If true: nested objects/arrays are appended as one JSON string under the parent key.
 *      If false: nested keys are flattened with bracket notation (e.g. parent[child]).
 *  - arrayFormat: "indices" | "brackets" | "repeat" (default "indices")
 *      How arrays are encoded when useJsonForNestedObjects === false:
 *        - indices: items => key[0], key[1]
 *        - brackets: items => key[]
 *        - repeat:   items => key, key, key
 */
function toFormData(
  obj,
  fd = new FormData(),
  namespace = '',
  options = { useJsonForNestedObjects: true, arrayFormat: 'indices' }
) {
  const { useJsonForNestedObjects, arrayFormat } = options;

  const isPlainObject = (v) => v && typeof v === 'object' && v.constructor === Object;
  const isFile = (v) => (typeof File !== 'undefined' && v instanceof File) || (typeof Blob !== 'undefined' && v instanceof Blob && v.name);
  const isFileList = (v) => (typeof FileList !== 'undefined' && v instanceof FileList);

  const append = (key, value) => {
    // normalize null/undefined to empty string to avoid "undefined"
    if (value === undefined || value === null) {
      fd.append(key, '');
      return;
    }
    // Files/Blobs should be appended as-is (File has name)
    if (isFile(value)) {
      // If the value is a plain Blob without a filename, append without filename
      if (value instanceof File) fd.append(key, value, value.name);
      else fd.append(key, value);
      return;
    }
    // Other primitives
    fd.append(key, String(value));
  };

  for (const [prop, value] of Object.entries(obj || {})) {
    const formKey = namespace ? `${namespace}[${prop}]` : prop;

    // Files & FileLists
    if (isFile(value)) {
      append(formKey, value);
    } else if (isFileList(value)) {
      // FileList: append each file with same key (or indexed depending on arrayFormat)
      const arr = Array.from(value);
      arr.forEach((file, i) => {
        if (arrayFormat === 'indices') fd.append(`${formKey}[${i}]`, file, file.name);
        else if (arrayFormat === 'brackets') fd.append(`${formKey}[]`, file, file.name);
        else fd.append(formKey, file, file.name); // repeat
      });
    } else if (Array.isArray(value)) {
      // Arrays of primitives/objects
      if (useJsonForNestedObjects) {
        // send whole array as JSON string
        append(formKey, JSON.stringify(value));
      } else {
        // flatten arrays into multiple entries
        value.forEach((item, i) => {
          if (isPlainObject(item) || Array.isArray(item)) {
            // nested object inside array: recurse with index namespace
            const keyForItem = arrayFormat === 'indices' ? `${formKey}[${i}]`
                              : arrayFormat === 'brackets' ? `${formKey}[]`
                              : formKey;
            if (isPlainObject(item)) {
              toFormData(item, fd, keyForItem, options);
            } else {
              // nested array inside array -> stringify
              fd.append(keyForItem, JSON.stringify(item));
            }
          } else if (isFile(item)) {
            const keyForFile = arrayFormat === 'indices' ? `${formKey}[${i}]` : arrayFormat === 'brackets' ? `${formKey}[]` : formKey;
            fd.append(keyForFile, item, item.name);
          } else {
            const keyForPrimitive = arrayFormat === 'indices' ? `${formKey}[${i}]` : arrayFormat === 'brackets' ? `${formKey}[]` : formKey;
            fd.append(keyForPrimitive, item == null ? '' : String(item));
          }
        });
      }
    } else if (isPlainObject(value)) {
      // Plain object: either JSON-stringify (one field) OR flatten recursively
      if (useJsonForNestedObjects) {
        append(formKey, JSON.stringify(value));
      } else {
        // recurse to flatten each nested key as parent[child]
        toFormData(value, fd, formKey, options);
      }
    } else if (value instanceof Date) {
      append(formKey, value.toISOString());
    } else {
      // primitive (string/number/boolean/null/undefined)
      append(formKey, value);
    }
  }

  return fd;
}


export const updateInvestorDetails = async (args) => {
  const token = process.env.REACT_APP_API_GUEST_TOKEN;
  const amcCode = sessionStorageUtil.getAmcCode();

  const formData = new FormData();

  formData.append("amc_code", amcCode);

  const checkFormData = toFormData({ ...args, "amc_code": amcCode });

  for (const [key, value] of Object.entries(args)) {
    formData.append(key, value);
  }

  // formData.forEach((value, key) => {
  //   console.log(key, value);
  // });

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/investor/update`,
      {
        method: "POST",
        headers: {
          Authorization: token,
        },
        body: checkFormData
      },
    );

    const results = await response.json();

    if (!response.ok || results?.status !== 200) {
      throw new Error(results.message || "Update Investor - Failed");
    }

    return {
      data: results.data,
      message: "Update Investor - Success",
      error: false,
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      message: error.message || "Get Unitholder Details - Failed",
      error: true,
    };
  }
};

export const loginWithCNIC = async (data) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/verify-login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });

  return response;
};

export const loginWithOTP = async (data) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/verify-otp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });

  return response;
};

export const getStaticSignupData = async (endpoint, options) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL + endpoint}?email=${process.env.REACT_APP_API_GUEST_EMAIL}`, options);

    const { data } = await response.json();

    if (!response.ok) {
      throw new Error('Failed to get static data');
    }

    return {
      data,
      err: false,
      message: data.message || 'GET api/static - Success'
    };
  } catch (err) {
    // console.log(err);
    return {
      data: null,
      err: true,
      message: err.message || 'GET api/static - Failed'
    };
  }
};

export const getBanks = async () => {
  const amcCode = sessionStorageUtil.getAmcCode();
  const token = process.env.REACT_APP_API_GUEST_TOKEN;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/bank?email=${process.env.REACT_APP_API_GUEST_EMAIL}&page_number=&page_size=&amc_code=${amcCode}`, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        Authorization: token
      }
    });

    const { data } = await response.json();

    if (!response.ok) {
      throw new Error('Failed to get bank data');
    }

    return {
      data,
      err: false,
      message: data.message || 'GET api/banks - Success'
    };
  } catch (err) {
    // console.log(err);
    return {
      data: null,
      err: true,
      message: err.message || 'GET api/banks - Failed'
    };
  }
};

export const forgotPassword = async (email) => {
  const token = process.env.REACT_APP_API_GUEST_TOKEN;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user/forgot-password`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
      }),
    });

    const data = await response.json();

    if (!response.ok || data.status !== 200) {
      if (Array.isArray(data.message)) {
        return {
          message: data.message,
          error: true,
        };
      } else {
        throw new Error(data?.message);
      }
    }

    return {
      message: data.message || "OTP sent successfully",
      error: false,
    };
  } catch (err) {
    // console.log(err);

    return {
      message: err?.message,
      error: true,
    };
  }
};

export const forgotPasswordVerifyOTP = async (data) => {
  const token = process.env.REACT_APP_API_GUEST_TOKEN;

  const { email, otp, password, confirm_password } = data;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user/verify-otp`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        otp,
        new_password: password,
        confirm_new_password: confirm_password,
      }),
    });

    const data = await response.json();

    // console.log(data);

    if (!response.ok || data?.status !== 200) {
      if (Array.isArray(data.message)) {
        return {
          message: data.message,
          error: true,
        };
      } else {
        throw new Error(data?.message);
      }
    }

    return {
      ...data,
      error: false,
    };
  } catch (err) {
    // console.log(err);

    return {
      data: null,
      message: err?.message,
      error: true,
    };
  }
};

export const userChangePassword = async (email, old_password, new_password) => {
  const token = sessionStorageUtil.getAccessToken();

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user/change-password`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        old_password,
        new_password,
      }),
    });

    const data = await response.json();

    // console.log(data);

    if (!response.ok || data?.status !== 200) {
      if (Array.isArray(data.message)) {
        return {
          data: null,
          message: data.message,
          error: true,
        };
      } else if (Object.keys(data).length === 0) {
        throw new Error("An Error Occurred, Try Again");
      } else {
        throw new Error(data?.message);
      }
    }

    return {
      ...data,
      error: false,
    };
  } catch (err) {
    // console.log(err);

    return {
      data: null,
      message: err?.message,
      error: true,
    };
  }
};
